import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApAnalyticsModule } from '@ap/analytics';
import { ApButtonComponent } from '@ap/button';
import { ApContentComponent, ApContentPipe } from '@ap/content';
import { ApPhonePipe } from '@ap/formatters';
import { ApIconComponent } from '@ap/icon';
import { ApIllustrationComponent } from '@ap/illustration';
import { MijnOverzichtTemplateModule } from '@ap/mijn-template';

import { PhonenumberValidationMoreinfoModalModule } from './modal/phonenumber-validation-moreinfo-modal.module';
import { PhoneNumberValidationComponent } from './phonenumber-validation.component';

@NgModule({
    imports: [
        ApButtonComponent,
        CommonModule,
        ApAnalyticsModule,
        ApContentComponent,
        ApContentPipe,
        MijnOverzichtTemplateModule,
        ApIllustrationComponent,
        ApIconComponent,
        PhonenumberValidationMoreinfoModalModule,
        ApPhonePipe
    ],
    exports: [],
    declarations: [PhoneNumberValidationComponent],
    providers: []
})
export class PhoneNumberValidationModule {}
